import styled from 'styled-components';
import {backgroundCover} from "../../core/styles";

const BkgImg = styled.div`
	${({src}) => backgroundCover(src)}	
`;
export default BkgImg;